import { paramsTypeCaster, toBoolean } from '@condo/helpers';
import { merge } from 'lodash-es';
import { ref } from 'vue';
import { useRoute } from 'vue-router';

const paramTypes = {
    showNotarized: toBoolean,
    showOpenSalesPackageEstates: toBoolean,
    page: Number,
    size: Number,
};

export const useEstateFilter = (initialData: Record<string, any>) => {
    const route = useRoute();

    const mergedFilter = paramsTypeCaster(merge({}, defaultQueryParams, initialData, route.query), paramTypes);

    const filter = ref(mergedFilter);

    const setFilter = updatedFilter => {
        filter.value = { ...updatedFilter };
    };

    return { filter, setFilter };
};

const defaultQueryParams = {
    orderBy: 'isScreened',
    order: 'DESC',
    page: 1,
    size: 50,
    sourcingState: [],
    sourcingPriority: [],
    purchasingState: [],
    renovationState: [],
    rentingState: [],
    sellingState: [],
    propertyManagementState: [],
    //location section
    state: [],
    county: [],
    city: [],
    region: [],
    zipcode: [],
    quarter: [],
    street: '',

    originalId: '',
    source: [],
    channelType: [],
    channelName: [],
    category: [],
    purchasingEntity: [],
    assignee: [],

    titleRegisterPage: undefined,

    adPublishingDateFrom: undefined,
    adPublishingDateTo: undefined,
    marginFrom: undefined,
    marginTo: undefined,
    priceFrom: '',
    priceTo: '',
    kitchen: undefined,
    toilet: undefined,
    condition: [],
    rejectionReason: [],
    estateId: [],
    isScored: undefined,
    hasPurchasing: undefined,
    hasRenovation: undefined,
    hasRenting: undefined,
    hasSelling: undefined,
    hasMfh: undefined,
    unScreened: undefined,
    withPortfolio: undefined,

    acceptedFrom: undefined,
    acceptedTo: undefined,
    offerFrom: undefined,
    offerTo: undefined,
    notaryFrom: undefined,
    notaryTo: undefined,
    handoverFrom: undefined,
    handoverTo: undefined,
    identifiedFrom: undefined,
    identifiedTo: undefined,
    inspectionFrom: undefined,
    inspectionTo: undefined,
    sellingPartner: undefined,

    portfolioId: [],
};
